import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import {
  AuthService, BreadcrumbService, CompanyService, ConfirmDialogService, HighlightService, HomeService, PanoramaService, StateService
} from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ProductName, SituViewWebApiClient, CreateSituViewChildRequest, 
  RenderedOutputStatus, SetRenderedOutputProductionRequest, SetRenderedOutputProductionResponse, 
  HomeConfigSlim, GetDefaultRenderedOutputRequest, GetDefaultRenderedOutputResponse, SetDefaultRenderedOutputRequest, 
  SetDefaultRenderedOutputResponse, CreateSituViewRequest,
  GetSituViewResponse, GetSituViewRequest, HomeConfig, EnvironmentName,
  ListIfcFilesByHomeIdRequest, HomeIfcFile, HomeIfcFileType, GetHomeConfigSlimIdRequest, GetHomeConfigSlimIdResponse, GetHomeConfigRequest, 
  GetHomeConfigResponse, HomeConfigFile, ListReleaseItemsRequest,
  ListReleaseItemsResponse,
  ArtifactEnvironment
} from 'situview-webapi-client';
import { 
  SituRenderServiceWebApiClient, AddPriorityConfigResponse, PriorityConfig, AddPriorityConfigRequest, HomeStatus, RenderType
} from 'siturenderservice-webapi-client';
import { ConfigService } from 'src/app/services/config.service';
import 'prismjs';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-regex';
import { ActivatedRoute, Router } from '@angular/router';
declare var Prism: any;
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { Guid } from 'guid-typescript';
import { ConfirmDialogData } from 'src/app/components/confirm-dialog/ConfirmDialogData';
import { Company } from 'identity-webapi-client';
import { CompleteHomeConfig } from 'src/app/shared/models/complete-homeconfig';
import { HomeProgress, situVIEWRequest } from '../situ-view-readonly/situ-view-readonly.component';
import { Role } from 'src/app/shared/models/role.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProductSelectorDialogComponent } from 'src/app/components';
import { ReleaseStyleTemplateDialogComponent, ReleaseStyleTemplateDialogComponentResultData } from '../../admin/product-releases/release-style-template-dialog/release-style-template-dialog.component';
import { ReleaseIssueDialogComponent, ReleaseIssueDialogComponentResultData } from '../../admin/product-releases/release-issue-dialog/release-issue-dialog.component';

@Component({
  selector: 'situ-view',
  templateUrl: './situ-view.component.html',
  styleUrls: ['./situ-view.component.less']
})
export class SituViewComponent extends SituBaseComponent {
  /* view high level controls */
  collapsed: boolean = false;
  paramId: string | undefined;
  initialised: boolean = false;
  isReleasePermitted: boolean = false;

  /* view data */
  renderedOutput: GetSituViewResponseExtended | undefined;
  readonly renderedOutputStatusEnum = RenderedOutputStatus;
  refreshToken: string | undefined;
  saveTemplateTrigger: string | undefined;
  styleTemplateSavePending: boolean = false;
  isParent: boolean = true;
  productNames = ProductName;
  editorMode: boolean = false;
  
  @ViewChild('homeConfiguration') homeConfiguration: ElementRef | undefined;
  @ViewChild('styleSelections') styleSelections: ElementRef | undefined;
  @ViewChild('configurationOptions') configurationOptions: ElementRef | undefined;

  /* embed code */
  apiCode = '';
  prismApiCode = '';
  embedCode = '';
  prismEmbedCode = '';
  highlighted: boolean = false;

  //listener outputs
  viewingAngle: number | undefined;
  verticalViewingAngle: number | undefined;
  selectedPanorama: string | undefined;
  selectedProductManufacturer: string | undefined;
  selectedProductSku: string | undefined;

  /* old stuff*/
  pluginManager: any;
  situSystems: any;

  isAdmin: boolean = false;
  isSituUser: boolean = false;
  isFurnishUser: boolean = false;
  
  selectedCompany: Company | undefined;
  artifactId: string | undefined;
  situViewUrl: string | undefined;

  panoramaProductName: ProductName = ProductName.Panorama;

  homeStatusEnum = HomeStatus;
  renderStatus: HomeStatus | undefined;
  renderStatusRoomAvailable: boolean = true;
  renderStatusProgress: number | undefined;
  renderStatusDescription: string | undefined;
  deviceHasGyro: boolean = false;
  showFloorPlan: boolean = false;
  groundFloorAvailable: boolean = false;
  firstFloorAvailable: boolean = false;
  secondFloorAvailable: boolean = false;
  selectedFloorPlan: number = 0;
  homeName: string | undefined;
  ifcFiles: string | undefined;

  selectedHomeConfig: CompleteHomeConfig | undefined;
  /* old stuff*/

  private _loading = false;
  get loading(): boolean { return this._loading; }
  set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  static readonlyType: string = "view";
  static readonlyPlanType: string = "plan";
  static readonlyRenderType: string = "render";

  constructor(
    authService: AuthService,
    stateService: StateService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    private breadcrumbService: BreadcrumbService,
    private configService: ConfigService,
    private companyService: CompanyService,
    private highlightService: HighlightService,
    private route: ActivatedRoute,
    private router: Router,
    private renderServiceClient: SituRenderServiceWebApiClient,
    private situViewClient: SituViewWebApiClient,
    private dialogService: ConfirmDialogService,
    private panoramaService: PanoramaService,
    private homeService: HomeService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog) { 
      super(authService, stateService);
      if (this.route.snapshot.params['id']) {
        this.paramId = this.route.snapshot.params['id'];
      } else if (this.route.snapshot.queryParams['id']) {
        this.paramId = this.route.snapshot.queryParams['id'];
      }
      this.breadcrumbService.setParam("home", "situVIEW");
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.stopPollingRenderStatus();
    if (this.initialised) {
      this.pluginManager.removeEventListener("floorplanavailable", this.floorPlanAvailableHandler);
      this.pluginManager.removeEventListener("roompanoramaavailable", this.roomPanoramaAvailableHandler);
      this.pluginManager.removeEventListener("homeconfigloadprogress", this.homeConfigLoadProgressHandler);
      this.pluginManager.removeEventListener("homeloaderror", this.homeLoadErrorHandler);
      this.pluginManager.removeEventListener("unhandlederror", this.unhandledErrorHandler);
      this.pluginManager.removeEventListener("viewinganglechange", this.viewingAngleHandler);
      this.pluginManager.removeEventListener("homeDetails", this.homeDetailsHandler);
      this.pluginManager.removeEventListener("productselection", this.productSelectionHandler);
      //new debugging fields
      this.pluginManager.removeEventListener("panoramaselected", this.panoramaSelectedHandler);
      this.pluginManager.removeEventListener("productcalloutshown", this.productCalloutShownHandler);
      this.pluginManager.removeEventListener("productcallouthidden", this.productCalloutHiddenHandler);
      // Gyroscope controls
      window.removeEventListener("devicemotion", this.deviceMotionListener);
    }
  }

  protected onSelectedCompanyChange(): void {
    if (!this.artifactId) this.selectedHomeConfig = undefined;
  }

  protected onSelectedHomeIfcFileId(homeIfcFileId: string) {
    //this.router.navigate([`/homes/furnish/${homeIfcFileId}`]);
    var url = this.router.serializeUrl(this.router.createUrlTree([`/homes/furnish/${homeIfcFileId}`]));
    window.open(url, '_blank'); // open in new tab
  }

  protected onUserChange(): void {
    this.isReleasePermitted = this.authService.hasAnyRole([Role.SituSystemsAdmin, Role.SituSystemsDeveloper, Role.SituSystemsEmployee, Role.BuilderAdmin, Role.Admin, Role.Release]);
    this.isFurnishUser = this.authService.hasSituAccess() || this.authService.hasRole(Role.SituFurnish);
    if (this.pluginManager) {
      this.pluginManager.authorizationHeaderValue = this.authService.getAuthorizationHeaderValue();
    }
  }

  ngAfterViewInit() {    
    this._subscriptions.push(this.panoramaService.onSituViewLoad.subscribe(() => {
      this.init();
    }));
    this.waitUntilTrue(() => this.initialised === true, 5000).then(() => {
      if (this.paramId) { //load by param first
        this.loadById(this.paramId);
      } else { //then try load a default
        this.getDefault()
        .then((response: void | GetDefaultRenderedOutputResponse) => {
          if (response?.renderedOutputId) {
            this.loadById(response.renderedOutputId);
          }
        });
      }
    });
  }

  private loadHomeIdViaSituView(artifactId: string) {
    if (!artifactId) return;
    if (!this.debugData) {
      this.pluginManager.load(new situVIEWRequest(new HomeConfig(), "kitchen", null, false, RenderType.BestAvailable, EnvironmentName.Production, artifactId, undefined, this.editorMode));
    } else {
      let roomSettings = new this.situSystems.RoomSettings();
      roomSettings.name = this.debugData.queryParams["panorama"];
      roomSettings.viewingAngle = parseFloat(this.debugData.queryParams["hlookat"] || '0');
      roomSettings.verticalViewingAngle = parseFloat(this.debugData.queryParams["vlookat"] || '0');
      let issueViewRequest = new situVIEWRequest(
        new HomeConfig(), 
        "kitchen", 
        [roomSettings], 
        false, 
        RenderType.BestAvailable, 
        EnvironmentName.Production,
        this.debugData.artifactId, 
        roomSettings?.name,
        this.editorMode
      );
      
      this.pluginManager.load(issueViewRequest);
      this.debugData = undefined;
      this.hasReleaseItems = true;
    }
  }
  
  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
    this.resizeModelViewer();
  }

  /* from children */
  selectedHomeId: string | undefined;
  selectedHomeConfigId: string | undefined;
  selectedStyleTemplateId: string | undefined;

  onHomeIdUpdates(homeId: string) {
    if (homeId && this.selectedHomeId !== homeId) {
      this.breadcrumbService.setParam("home", "situVIEW");
      this.selectedHomeId = homeId;
    }
  }

  onHomeConfigUpdates(homeConfig: HomeConfig) {
    this.homeName = homeConfig.home?.toLowerCase();
    this.breadcrumbService.setParam("home", "situVIEW - " + this.homeName);
    this.ifcFiles = homeConfig.masterFile?.toLowerCase();
    if (homeConfig.options) {
      for (var i = 0; i < homeConfig.options.length; i++) {
        if (this.ifcFiles) {
          this.ifcFiles += ',';
        }
        this.ifcFiles += homeConfig.options[i]?.toLowerCase();
      }
    }
  }
  
  onHomeConfigIdUpdates(homeConfigId: string) {
    if (this.renderedOutput && this.selectedHomeConfigId === this.renderedOutput.homeConfigId && (!homeConfigId || homeConfigId !== this.selectedHomeConfigId)) {
      this.clear();
    }
    if (homeConfigId) {
      if (this.selectedHomeConfigId !== homeConfigId) {
        this.selectedHomeConfigId = homeConfigId;
      }
    } else {
      this.selectedHomeConfigId = homeConfigId;
    }
  }

  onStyleTemplateIdUpdates(styleTemplateId: string) {
    if (this.renderedOutput?.styleConfigTemplate && this.selectedStyleTemplateId === this.renderedOutput.styleConfigTemplate.id && (!styleTemplateId || styleTemplateId !== this.selectedStyleTemplateId)) {
      this.clear();
    }
    if (styleTemplateId) {
      if (this.selectedStyleTemplateId !== styleTemplateId) {
        this.selectedStyleTemplateId = styleTemplateId;
      }
    } else {
      this.selectedStyleTemplateId = styleTemplateId;
    }
  }

  onSavePendingUpdates(savePending: boolean) {
    if (this.styleTemplateSavePending !== savePending) {
      this.styleTemplateSavePending = savePending;
    }
  }

  onIssueSelect(issueUrl: string) {
    let processedUrl = this.parseUrl(issueUrl);
    if (processedUrl?.artifactId) {
      this.debugData = processedUrl;
      this.loadById(processedUrl?.artifactId);
    }
  }
  debugData: { artifactId: string; queryParams: Record<string, string> } | undefined;
  parseUrl(url: string): { artifactId: string; queryParams: Record<string, string> } {
    const result: { artifactId: string; queryParams: Record<string, string> } = {
      artifactId: '',
      queryParams: {},
    };
  
    try {
      const pathAndQuery = url.split('/').slice(3).join('/');
      const [path, queryString] = pathAndQuery.split('?');
  
      const guidMatch = path.match(/^[0-9a-fA-F-]{36}$/);
      if (guidMatch) {
        result.artifactId = guidMatch[0];
      }
  
      if (queryString) {
        queryString.split('&').forEach((param) => {
          const [key, value] = param.split('=');
          if (key) {
            result.queryParams[key] = decodeURIComponent(value || '');
          }
        });
      }
    } catch (error) {
      console.error('Error parsing URL:', error);
    }
  
    return result;
  }
  /* from children */

  productWidth: number = 150;
  productHeight: number = 150;
  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;

  panoWidth: number = 800;
  panoHeight: number = 600;
  @ViewChild('panoContainer') panoContainer: ElementRef | undefined;

  toggleEditorMode() {
    this.editorMode = !this.editorMode;
    if (this.renderedOutput?.artifactId) {
      this.loadHomeIdViaSituView(this.renderedOutput.artifactId);
    }
  }

  selectFloorPlan(floor: number) {
    this.selectedFloorPlan = floor;
  }

  scrollToHomeConfiguration() {
    this.homeConfiguration!.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  scrollToStyleSelections() {
    this.styleSelections!.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  scrollToConfigurationOptions() {
    this.configurationOptions!.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  private generateSituLink() {
    const baseUrl = this.configService.config.situLinkBaseUrl 
      ? `https://view.${this.configService.config.situLinkBaseUrl}`
      : this.configService.config.situPortalBaseUrl;
  
    const url = new URL(baseUrl);
    url.pathname = this.artifactId ?? '/';
  
    if (this.selectedPanorama) {
      url.searchParams.set('panorama', this.selectedPanorama);
  
      if (this.viewingAngle) {
        url.searchParams.set('hlookat', this.viewingAngle.toString());
      }
  
      if (this.verticalViewingAngle) {
        url.searchParams.set('vlookat', this.verticalViewingAngle.toString());
      }
  
      if (this.selectedProductManufacturer) {
        url.searchParams.set('manufacturer', this.selectedProductManufacturer);
      }
  
      if (this.selectedProductSku) {
        url.searchParams.set('sku', this.selectedProductSku);
      }
    }

    return url;
  }

  copyDebugUrl() {
    const url = this.generateSituLink();
    this.clipboard.copy(url.toString());
    this.showMessage("Copied share location to clipboard!");
  }

  renderChild(productName: ProductName, existingArtifactId: string) {
    if (productName === undefined || !this.renderedOutput) {
      return;
    }

    if (existingArtifactId) {
      this.loadById(existingArtifactId);
      return;
    }
    let productNameString = ProductName[productName];
    let options = {
      title: `Render ${productNameString}`,
      message: `Are you sure you want to render this home as ${productNameString}? Excessive high quality renders may cause delays.`,
      cancelText: 'Cancel',
      confirmText: 'Render',
      actionIcon: 'add',
      actionColour: 'primary'
    } as ConfirmDialogData;

    this.dialogService.open(options);
    this._subscriptions.push(this.dialogService.confirmed()
      .subscribe(confirmed => {
        if (confirmed) {
          this.createSituViewChildInternal(productName)
            .then((response: GetSituViewResponse | void) => {
              if (response && response?.success && response?.id) {
                if (response.status === RenderedOutputStatus.Complete) {
                  let extendedResponse = new GetSituViewResponseExtended(response);
                  this.generateUrls(extendedResponse);
                  this.generateEmbedCode(extendedResponse);
                  this.generateResArtifactIds(extendedResponse);
                  this.renderedOutput = extendedResponse;
                  this.updateParams(extendedResponse?.id);
                } else {
                  this.startPollingRenderStatus(response.id);
                }
              }
            });
        }
      })
    );
  }

  createSituViewChildInternal(productName: ProductName): Promise<void | GetSituViewResponse> {
    let request = new CreateSituViewChildRequest();
    request.companyId = this.selectedCompany?.id;
    request.renderedOutputId = this.renderedOutput?.id;
    request.productName = productName;
    let environment = new ArtifactEnvironment();
    environment.company = this.selectedCompany?.code;
    environment.environment = EnvironmentName.Latest;
    request.environmentOverride = environment;

    return this.situViewClient.createSituViewChild(request)
      .then((response: GetSituViewResponse) => {
          if (!response.success) {
            this.showMessage(`Sorry! There was an issue rendering this home at ${productName}. Please try again.`);
          } else {
            this.showMessage(`You have successfully queued this home to render at ${productName}`);
          }
          return response;
      })
      .catch((x: any) => {
          this.showMessage("Sorry! There was an issue rendering this home at a higher resolution. Please try again.");
          return 
      });
  }

  setDefault(isGlobal: boolean = false) {
    let request = new SetDefaultRenderedOutputRequest();
    request.companyId = this.selectedCompany?.id;
    request.productName = this.panoramaProductName;
    request.isUserRequest = !isGlobal;
    request.renderedOutputId = this.renderedOutput?.id;

    this.situViewClient.setDefaultRenderedOutput(request)
      .then((response: SetDefaultRenderedOutputResponse) => {
          if (!response.success) {
              this.showMessage("Sorry! There was an issue setting the default. Please try again.");
          } else {
              this.showMessage(`You have successfully set this configuration as ${isGlobal ? 'the global' : 'your'} default!`);
          }
      })
      .catch((x: any) => {
          this.showMessage("Sorry! There was an issue at our end setting the default. Please try again.");
      });
  }

  getDefault(): Promise<void | GetDefaultRenderedOutputResponse> {
    let request = new GetDefaultRenderedOutputRequest();
    request.companyId = this.selectedCompany?.id;
    request.productName = this.panoramaProductName;
    request.isUserRequest = true;

    return this.situViewClient.getDefaultRenderedOutput(request)
      .then((response: GetDefaultRenderedOutputResponse) => {
          return response;
      })
      .catch((x: any) => {
          this.showMessage("Sorry! There was an issue at our end getting the default. Please try again.");
      });
  }

  toggleFullscreen() {
    this.pluginManager.toggleFullScreen();
  };

  toggleGyro() {
    this.pluginManager.toggleGyro();
  };

  toggleFloorplan() {
    this.showFloorPlan = !this.showFloorPlan;
  };

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  };

  waitUntilTrue(condition: () => boolean, timeout: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const interval = setInterval(() => {
        if (condition()) {
          clearInterval(interval);
          resolve();
        } else {
          timeout -= 1000;
          if (timeout <= 0) {
            clearInterval(interval);
            reject(new Error("Timeout"));
          }
        }
      }, 1000);
    });
  }

  copyToClipboard(text: string) {
    this.clipboard.copy(text);
    this.snackBar.open(`Copied to clipboard.`, "Close", {
      duration: 5000,
      panelClass: ['copied-snackbar']
    });
  }

  clear() {
    this.loading = false;
    this.renderedOutput = undefined;
    this.stopPollingRenderStatus();
  }

  refreshData() {
    this.refreshToken = Guid.create().toString();
  }

  saveTemplate() {
    this.saveTemplateTrigger = Guid.create().toString();
  }

  updateParams(renderedOutputId?: string, comparisonRenderedOutputId?: string) {
    const urlTree = this.router.createUrlTree([], {
      queryParams: { id: renderedOutputId },
      queryParamsHandling: "merge",
      preserveFragment: true
    });

    if (renderedOutputId) {
      if (comparisonRenderedOutputId) {
        urlTree.queryParams = comparisonRenderedOutputId ? { id: renderedOutputId, to: comparisonRenderedOutputId } : {};
      } else {
        urlTree.queryParams = renderedOutputId ? { id: renderedOutputId } : {};
      }
    }

    this.router.navigateByUrl(urlTree);
  }

  queue() {
    if (this.renderedOutput) {
      let request = new AddPriorityConfigRequest();
      request.companyId = this.selectedCompany?.id;
      request.productName = ProductName.Panorama;
      let priorityConfig = new PriorityConfig();
      request.priorityConfig = priorityConfig;

      this.renderServiceClient.addPriorityConfig(request)
        .then((response: AddPriorityConfigResponse) => {
          if (response.success) {
            this.showMessage("Success! This home config has been added to your priority home queue.");
          } else {
            this.showMessage("Sorry! There was an issue at our end adding this home config to the priority render queue. Please try again.");
          }
        })
        .catch((err: any) => { this.showMessage("Sorry! There was an issue at our end adding this home config to the priority render queue. Please try again.")});
    }
  };

  browse(styleId?: string, configId?: string) {
    let queryParams;
    if (styleId && configId) {
      queryParams = { queryParams: { style: styleId, config: configId } };
    } else if (styleId) {
      queryParams = { queryParams: { style: styleId } };
    } else if (configId) {
      queryParams = { queryParams: { config: configId } };
    } else {
      queryParams = {};
    }
    this.router.navigate(['/situ-view/browse', this.panoramaProductName], queryParams);
  }

  render() {
    this.loading = true;
    this.renderedOutput = undefined;
    this.stopPollingRenderStatus();

    let request = new CreateSituViewRequest();
    request.companyId = this.selectedCompany?.id;
    request.homeConfigId = this.selectedHomeConfigId;
    request.styleConfigTemplateId = this.selectedStyleTemplateId;

    if (!request.homeConfigId || !request.styleConfigTemplateId) {
      this.loading = false;
      this.showMessage("Sorry! The config does not appear to be valid. Please check your config and try again.");
      return;
    }

    this.situViewClient.createSituView(request)
      .then((createResponse: GetSituViewResponse) => {
        if (createResponse.success && createResponse?.id) {
          if (createResponse?.status === RenderedOutputStatus.Complete) {
            let extendedResponse = new GetSituViewResponseExtended(createResponse);
            this.generateUrls(extendedResponse);
            this.generateEmbedCode(extendedResponse);
            this.generateResArtifactIds(extendedResponse);
            this.renderedOutput = extendedResponse;
            this.updateParams(extendedResponse?.id);
            this.loadHomeIdViaSituView(extendedResponse.artifactId!);
          } else {
            this.startPollingRenderStatus(createResponse.id);
          }
        } else {
          this.showMessage("Sorry! There was an issue at our end retrieving your renders. Please try again.");
        }
      })
      .catch((x: any) => {
        this.showMessage("Sorry! There was an issue at our end retrieving your renders. Please try again.");
      });
  }

  loadById(renderedOutputId: string, isPolling: boolean = false) {
    this.loading = true;

    if (!isPolling) {
      this.paramId = undefined;
      this.renderedOutput = undefined;
      this.homeName = undefined;
      this.breadcrumbService.setParam("home", "situVIEW");
      this.ifcFiles = undefined;
    }

    this.getSituViewById(renderedOutputId)
      .then((getViewResponse: GetSituViewResponse) => {
        /* do the company check */
        if (getViewResponse?.companyId && getViewResponse?.companyId != this.selectedCompany?.id) {
          if (!this.authService.isAuthorizedForCompanyById(getViewResponse.companyId)) {
            this.showMessage(`Sorry! Your are not authorized for company ${getViewResponse}.`);
            this.router.navigateByUrl('/unauthorized');
            return;
          }

          this.companyService.getCompanyById(getViewResponse.companyId)
            .then((company) => {
              if (!company) return;

              this.stateService.state = {
                ...this.stateService.state,
                company
              };
            });
        }

        if (getViewResponse?.success && getViewResponse?.id) {
          if (this.renderedOutput?.id !== getViewResponse?.id || this.renderedOutput.status !== getViewResponse?.status) {
            let extendedResponse = new GetSituViewResponseExtended(getViewResponse);
            if (this.renderedOutput?.id !== getViewResponse?.id) {
              this.generateUrls(extendedResponse);
              this.generateEmbedCode(extendedResponse);
              this.generateResArtifactIds(extendedResponse);
              
              // Store the response but don't set renderedOutput yet to prevent race condition
              const tempRenderedOutput = extendedResponse;
              tempRenderedOutput.status = extendedResponse.status;

              this.updateParams(tempRenderedOutput?.id!);
              
              if (getViewResponse.productName !== ProductName.Plan && getViewResponse.productName !== ProductName.Render) {
                // Load home data first, then set renderedOutput to prevent child component race condition
                this.loadHomeIdViaSituView(tempRenderedOutput?.artifactId!);
                
                // Wait a tick to ensure home config loading starts before setting renderedOutput
                setTimeout(() => {
                  this.renderedOutput = tempRenderedOutput;
                }, 100);
              } else {
                // For Plan and Render products, set immediately as they don't need home config
                this.renderedOutput = tempRenderedOutput;
              }
            } else if (this.renderedOutput.status !== getViewResponse?.status) {
              this.renderedOutput.status = getViewResponse.status;
              // if (getViewResponse.status && [RenderedOutputStatus.InProgress].includes(getViewResponse.status) && getViewResponse.productName !== ProductName.Plan && getViewResponse.productName !== ProductName.Render) {
              //   this.loadHomeIdViaSituView(this.renderedOutput?.artifactId!);
              // }
            }

            if (!this.renderedOutput?.status || !this.renderedOutput?.id) return;

            if (!isPolling && ([RenderedOutputStatus.InProgress, RenderedOutputStatus.Queued].includes(this.renderedOutput?.status))) {
              //this.refreshData();
              this.startPollingRenderStatus(this.renderedOutput.id!);
              return;
            }

            if ([RenderedOutputStatus.Failed].includes(this.renderedOutput.status)) {
              this.loading = false;
              //this.refreshData();
              this.stopPollingRenderStatus();
              this.showMessage("Sorry! Our system failed trying to render your situVIEW. Please try again.");
              return;
            }
            
            if ([RenderedOutputStatus.Complete].includes(this.renderedOutput?.status)) {
              this.getReleaseItems();
              this.loading = false;
              if (this.pollingInterval) {
                this.homeService.clearRenderedOutputsCache(this.selectedCompany?.id, getViewResponse?.productName);
              }
              //this.refreshData();
              this.stopPollingRenderStatus();
            }
          }
        } else {
          //this.showMessage("Sorry! There was an issue at our end retrieving your render. Please try again.");
        }
      })
      .catch((err: any) => {
        //this.showMessage("Sorry! There was an issue at our end retrieving your render. Please try again.");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  sendToLive() {
    let options = {
      title: `Send to Live?`,
      message: `Are you sure you want to send to Live? This might override Live renders on your website!`,
      cancelText: 'Cancel',
      confirmText: 'Confirm',
      actionIcon: 'add',
      actionColour: 'primary'
    } as ConfirmDialogData;

    this.dialogService.open(options);
    this._subscriptions.push(this.dialogService.confirmed()
      .subscribe(confirmed => {
        if (confirmed) {
          let request = new SetRenderedOutputProductionRequest();
          request.companyId = this.selectedCompany?.id;
          request.renderedOutputId = this.renderedOutput?.id;

          this.situViewClient.setRenderedOutputProduction(request)
            .then((response: SetRenderedOutputProductionResponse) => {
              if (response.success) {
                this.showMessage("This has been set to Live!");
              }
            })
            .catch((x: any) => {
              this.showMessage("Sorry! There was an issue at our end. Please try again.");
            });
        }
      })
    );
  }

  private generateUrls(getViewResponse: GetSituViewResponseExtended): void {
    switch(getViewResponse.productName) {
      case ProductName.Plan:
        getViewResponse.situPlanUrl = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactid=${getViewResponse.artifactId}&filename=home.glb`;
        break;
      case ProductName.Render:
        getViewResponse.situRenderUrls = getViewResponse.files?.map((file: HomeConfigFile) => {
          return `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${getViewResponse.artifactId}&filename=${file.fileName}`;
        }) ?? [];
        break;
    }
  }
  
  private generateEmbedCode(getViewResponse: GetSituViewResponseExtended): void {
    getViewResponse.apiCode = this.getApiCode(getViewResponse);
    getViewResponse.prismApiCode = Prism.highlight(getViewResponse.apiCode, Prism.languages['markup'], 'markup');
  }

  private generateResArtifactIds(getViewResponse: GetSituViewResponseExtended): void {
    if (getViewResponse.parentRenderedOutputId || getViewResponse.productName !== ProductName.Panorama) {
      this.isParent = false;
      getViewResponse.resStandardArtifactId = getViewResponse.parentRenderedOutput?.artifactId;
      switch (getViewResponse.productName) {
        case ProductName.RayTraced:
          getViewResponse.resRaytracedArtifactId = getViewResponse.artifactId;
          break;
        case ProductName.RayTracedPlus:
          getViewResponse.resRaytracedPlusArtifactId = getViewResponse.artifactId;
          break;
        case ProductName.VR:
          getViewResponse.resVrArtifactId = getViewResponse.artifactId;
          break;
        case ProductName.Plan:
          getViewResponse.resPlanArtifactId = getViewResponse.artifactId;
          break;
        case ProductName.Insights:
          getViewResponse.resInsightsArtifactId = getViewResponse.artifactId;
          break;
        case ProductName.Render:
          getViewResponse.resRenderArtifactId = getViewResponse.artifactId;
          break;
        case ProductName.Unreal:
          getViewResponse.resUnrealArtifactId = getViewResponse.artifactId;
          break;
        default: //2048x1536
          break;
      }
    } else {
      this.isParent = true;
      getViewResponse.resStandardArtifactId = getViewResponse.artifactId;
      if (getViewResponse.renderedOutputChildren) {
        getViewResponse.renderedOutputChildren.forEach(child => {
          if (child.productName === ProductName.RayTraced && child.status === RenderedOutputStatus.Complete) getViewResponse.resRaytracedArtifactId = child.artifactId;
          if (child.productName === ProductName.RayTracedPlus && child.status === RenderedOutputStatus.Complete) getViewResponse.resRaytracedPlusArtifactId = child.artifactId;
          if (child.productName === ProductName.VR && child.status === RenderedOutputStatus.Complete) getViewResponse.resVrArtifactId = child.artifactId;
          if (child.productName === ProductName.Plan && child.status === RenderedOutputStatus.Complete) getViewResponse.resPlanArtifactId = child.artifactId;
          if (child.productName === ProductName.Insights && child.status === RenderedOutputStatus.Complete) getViewResponse.resInsightsArtifactId = child.artifactId;
          if (child.productName === ProductName.Render && child.status === RenderedOutputStatus.Complete) getViewResponse.resRenderArtifactId = child.artifactId;
          if (child.productName === ProductName.Unreal && child.status === RenderedOutputStatus.Complete) getViewResponse.resUnrealArtifactId = child.artifactId;
        });
      }
    }
  }

  private getSituViewById(renderedOutputId: string): Promise<GetSituViewResponse> {
    let request = new GetSituViewRequest();
    request.renderedOutputId = renderedOutputId;

    return this.situViewClient.getSituView(request);
  }

  /* polling */
  pollingInterval: NodeJS.Timeout | null = null;
  pollingFails = 0;

  private startPollingRenderStatus(renderedOutputId: string) {
    if (!this.pollingInterval) {
      this.pollingFails = 0;

      this.loadById(renderedOutputId, false); // start immediately in case it's a cached render
      this.pollingInterval = setInterval(() => { this.loadById(renderedOutputId, true); }, 10000);
    }
  }

  private stopPollingRenderStatus() {
    if (!!this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }
  /* polling */

  private getApiCode(getViewResponse: GetSituViewResponseExtended) {
    let homeConfig = getViewResponse.homeConfig;
    let apiCode = 
  `<!-- 1. This code will set the divs for plugins, reference the situVIEW -->
 <!-- library and add some basic styling. -->
  <html>
    <head>
      <style>
        #SituPanoramaViewer {
          width: 600px;
          height: 300px;
          margin: 20px;
        }
        
        body {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      </style>
    </head>
    <body>
      <!-- Panorama Viewer Div -->
      <div id="SituPanoramaViewer"></div>
      <!-- Interactive Ground Floor Div -->
      <div id="SituInteractiveGroundFloorplan"></div>
      
      <!-- situVIEW library -->
      <script src="${this.configService.config.situViewJsUrl}"></script>
    </body>
  </html>
  
  <script>
  // 2. This code loads the situVIEW library and configures the panorama 
  // and floorplan settings with default values.
    var situView = SituSystems.SituView;

    var defaultPanoramaSettings = new SituSystems.PanoramaSettings();
    var defaultFloorplanSettings = new SituSystems.FloorplanSettings()

  // 3. This code loads the floorplan and viewer plugins in the divs 
  // we specified in our <html> above
    situView.addPlugin(
      new SituSystems.PanoramaViewer("SituPanoramaViewer", defaultPanoramaSettings)
    );
  
    situView.addPlugin(
      new SituSystems.SVGFloorPlan(
        "SituInteractiveGroundFloorplan",
        SituSystems.Floors.GROUND,
        true,
        defaultFloorplanSettings
      )
    );

  // 4. This code loads a home configuration after the library has been initialised
    situView.onInit = function () {
      situView.load({
        homeConfig: {
          builder: "${this.selectedCompany?.code}",
          home: "${homeConfig?.home}",
          masterFile: "${homeConfig?.masterFile}",
          themes: ["${getViewResponse.styleConfigTemplate?.name}"],
          options: ${JSON.stringify(homeConfig?.options || [])},
        },
        startingRoom: "kitchen"
      });
    };

  // 5. This code initialises the situVIEW library
    situView.init();
  </script>`;

    return apiCode;
  }

  share(forInternal: boolean = false) {
    if (this.renderedOutput?.id) {
      if (forInternal) {
        this.clipboard.copy(`${this.configService.config.situPortalBaseUrl}/situ-view?id=${this.renderedOutput.id}`);
        this.showMessage("Copied url to clipboard!");
      } else {
        let productName = "view";
        switch(this.renderedOutput.productName) {
          case ProductName.Plan:
            productName = SituViewComponent.readonlyPlanType;
            break;
          case ProductName.Render:
            productName = SituViewComponent.readonlyRenderType;
            break;
        }
        let url = this.configService.config.situLinkBaseUrl ?
          `https://${productName}.${this.configService.config.situLinkBaseUrl}/${this.renderedOutput.artifactId}` :
          `${this.configService.config.situPortalBaseUrl}/${this.renderedOutput.artifactId}`;
        this.clipboard.copy(url);
        this.showMessage("Copied situLINK to clipboard!");
      }
    };
  };

  releaseIssueDialogRef: MatDialogRef<ReleaseIssueDialogComponent> | undefined;
  addEditReleaseIssue() {
    const url = this.generateSituLink();
    this.releaseIssueDialogRef = this.dialog.open(ReleaseIssueDialogComponent, {
      panelClass: 'modal-panel',
      width: '60%',
      height: '80%',
      disableClose: true,
      data: {
        isSituUser: this.isSituUser,
        companyId: this.selectedCompany?.id,
        reportedSituLink: url,
        renderedOutputId: this.renderedOutput?.parentRenderedOutputId ? this.renderedOutput?.parentRenderedOutputId : this.renderedOutput?.id,
        linkedReleaseItemIds: this.releaseItems,
        reportedSituLinkProductName: ProductName.Panorama
      }
    });

    this._subscriptions.push(this.releaseIssueDialogRef.afterClosed()
      .subscribe((data: ReleaseIssueDialogComponentResultData) => {
        if (data?.refreshNeeded) {
          this.showMessage("Release Issue has been logged!");
        }
      })
    );
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }

  private init() {
    this.situSystems = this.panoramaService.situSystems;
    if (!this.pluginManager) {
      this.pluginManager = this.panoramaService.createPluginManager();
    }

    let settings = new this.situSystems.PanoramaSettings();
    settings.overlayElementId = 'panorama-top-overlay';
    settings.imageSize = 4096; // Typically 1024, 2048, 4096
    settings.fieldOfView = 75;
    settings.minFieldOfView = 40;
    settings.maxFieldOfView = 110;
    settings.adjustableFieldOfView = false;
    settings.enableGyro = true;

    var defaultFloorplanSettings = new this.situSystems.FloorplanSettings();

    this.pluginManager.addPlugin(new this.situSystems.PanoramaViewer("viewer", settings));
    this.pluginManager.addPlugin(new this.situSystems.SVGFloorPlan("ground-floor-plan", this.situSystems.Floors.GROUND, true, defaultFloorplanSettings));
    this.pluginManager.addPlugin(new this.situSystems.SVGFloorPlan("first-floor-plan", this.situSystems.Floors.FIRST, true, defaultFloorplanSettings));
    this.pluginManager.addPlugin(new this.situSystems.SVGFloorPlan("second-floor-plan", this.situSystems.Floors.SECOND, true, defaultFloorplanSettings));

    this.pluginManager.addEventListener("floorplanavailable", this.floorPlanAvailableHandler);
    this.pluginManager.addEventListener("roompanoramaavailable", this.roomPanoramaAvailableHandler);
    this.pluginManager.addEventListener("homeconfigloadprogress", this.homeConfigLoadProgressHandler);
    this.pluginManager.addEventListener("homeloaderror", this.homeLoadErrorHandler);
    this.pluginManager.addEventListener("unhandlederror", this.unhandledErrorHandler);
    this.pluginManager.addEventListener("viewinganglechange", this.viewingAngleHandler);
    this.pluginManager.addEventListener("homeDetails", this.homeDetailsHandler);
    this.pluginManager.addEventListener("productselection", this.productSelectionHandler);
    //new debugging fields
    this.pluginManager.addEventListener("panoramaselected", this.panoramaSelectedHandler);
    this.pluginManager.addEventListener("productcalloutshown", this.productCalloutShownHandler);
    this.pluginManager.addEventListener("productcallouthidden", this.productCalloutHiddenHandler);
    // Gyroscope controls
    window.addEventListener("devicemotion", this.deviceMotionListener);

    this.initialised = true;
  }

  private deviceMotionListener: (event: DeviceMotionEvent) => void = (event: DeviceMotionEvent) => {
    if (event?.rotationRate?.alpha || event?.rotationRate?.beta || event?.rotationRate?.gamma) {
      if (!this.deviceHasGyro) {
        this.deviceHasGyro = true;
      }
    }
  };

  private floorPlanAvailableHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail?.floorPlanName) {
      this.renderStatusRoomAvailable = true;
      switch (e?.detail?.floorPlanName) {
        case "GROUND":
          this.groundFloorAvailable = true;
          break;
        case "FIRST":
          this.firstFloorAvailable = true;
          break;
        case "SECOND":
          this.secondFloorAvailable = true;
          break;
      }
    }
  };

  private roomPanoramaAvailableHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    this.renderStatusRoomAvailable = true;
  };

  private homeConfigLoadProgressHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail) {
      //console.log(e?.detail);
      const homeProgress = e.detail as HomeProgress;
      if (homeProgress) {
        if (homeProgress.percentComplete === -1) {
          this.renderStatus = HomeStatus.Failed;
          this.renderStatusDescription = homeProgress.description;
        } else if (homeProgress.percentComplete === 100) {
          this.renderStatus = undefined;
          this.renderStatusProgress = undefined;
          this.renderStatusDescription = undefined;
        } else if (homeProgress.percentComplete >= 2 && homeProgress.percentComplete <= 99) {
          this.renderStatus = HomeStatus.InProgress;
          this.renderStatusProgress = homeProgress.percentComplete;
          this.renderStatusDescription = homeProgress.description;
        } else {
          this.renderStatus = HomeStatus.Queued;
          this.renderStatusDescription = homeProgress.description;
        }
      }
    }
  };

  private homeLoadErrorHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    //console.log(e?.detail);
    if (e?.detail) {
      this.renderStatus = HomeStatus.Failed;
      this.renderStatusDescription = `Sorry! We failed to render this home. ${e.detail}`;
    } else {
      this.renderStatus = HomeStatus.Failed;
      this.renderStatusDescription = "Sorry! We failed to render this home. Please try again.";
    }
  };

  private unhandledErrorHandler: (e: ErrorEvent) => void = (e: ErrorEvent) => {
    //console.log(e);
    if (e?.error) {
      this.renderStatus = HomeStatus.Failed;
      this.renderStatusDescription = `Sorry! We failed to render this home. ${e.error?.message}`;
      if ("WEBGL_CONTEXT_LOST" === e.error?.message) {
        console.log(`Sorry! We failed to render this home. ${e.error?.message}`);
      }
    } else {
      this.renderStatus = HomeStatus.Failed;
      this.renderStatusDescription = "Sorry! We failed to render this home. Please try again.";
    }
  };

  private viewingAngleHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail?.viewingAngle) {
      this.viewingAngle = e.detail.viewingAngle;
      this.verticalViewingAngle = e.detail.verticalViewingAngle;
    }
  };

  private homeDetailsHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail?.artifactId) {
      if (this.artifactId !== e.detail.artifactId) this.artifactId = e.detail.artifactId;
    }
  };

  private panoramaSelectedHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    //console.log(e);
    if (e?.detail?.panoramaName && this.selectedPanorama !== e.detail.panoramaName) {
      this.selectedPanorama = e.detail.panoramaName;
    }
  };

  private productCalloutShownHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail?.manufacturer && e?.detail?.sku) {
      this.selectedProductManufacturer = e.detail.manufacturer;
      this.selectedProductSku = e.detail.sku;
    }
  };

  private productCalloutHiddenHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail?.manufacturer && e?.detail?.sku) {
      this.selectedProductManufacturer = undefined;
      this.selectedProductSku = undefined;
    }
  };

  dialogRef: MatDialogRef<ProductSelectorDialogComponent> | undefined;
  private productSelectionHandler: (e: CustomEvent) => void = (e: CustomEvent) => {
    if (e?.detail?.artifactId) {
      this.dialogRef = this.dialog.open(ProductSelectorDialogComponent, {
        width: "600px",
        height: "600px",
        data: {
          companyId: this.selectedCompany?.id
        }
      });
    }
  };

  private resizeModelViewer() {
    if (this.modelContainer) {
      const parentWidth = this.modelContainer.nativeElement.offsetWidth;
      this.productWidth = parentWidth;
      this.productHeight = (parentWidth / 4) * 2.8;
      this.cdr.detectChanges();
    }
  }

  /* releases */
  releaseItemDialogRef: MatDialogRef<ReleaseStyleTemplateDialogComponent> | undefined;
  copyToStyleTemplate(homeConfigIds: string[]) {
    if (!homeConfigIds || homeConfigIds.length < 1) {
      this.showMessage("Please select some home configurations");
      return;
    }

    this.releaseItemDialogRef = this.dialog.open(ReleaseStyleTemplateDialogComponent, {
      panelClass: 'modal-panel',
      width: '60%',
      height: '80%',
      data: {
        companyId: this.selectedCompany?.id,
        productName: this.panoramaProductName,
        homeConfigIds: homeConfigIds
      }
    });

    this._subscriptions.push(this.releaseItemDialogRef.afterClosed()
      .subscribe((data: ReleaseStyleTemplateDialogComponentResultData) => {
        if (data) {
          this.showMessage(`${data.releaseItemCount} release items added across ${data.releaseCount} releases!`);
        }
      })
    );
  }

  addToRelease(type: string) {
    if (!this.selectedHomeId || !this.selectedHomeConfigId || !this.selectedStyleTemplateId) {
      return;
    }
    switch (type) {
      case "Single":
        this.copyToStyleTemplate([this.selectedHomeConfigId!]);
        break;
      case "MasterFiles":
        let masterHomeConfigIds: string[] = [];
        this.getHomeConfig(this.selectedHomeConfigId)
          .then((getHomeConfigResponse: GetHomeConfigResponse | void) => {
            if (getHomeConfigResponse?.success && getHomeConfigResponse.homeConfig) {
              this.loadIfcFiles(this.selectedHomeId!)
                .then((response: any) => {
                  if (response.success && response.ifcFiles) {
                    let hcs = new HomeConfigSlim();
                    hcs.home = getHomeConfigResponse.homeConfig!.home;
                    hcs.options = getHomeConfigResponse.homeConfig!.options;
                    hcs.companyId = this.selectedCompany?.id;

                    const masterPromises: Promise<string | undefined>[] = response.ifcFiles
                      .filter((x: HomeIfcFile) => x.type === HomeIfcFileType.Master)
                      .map((ifcFile: HomeIfcFile) => {
                        hcs.masterFile = ifcFile.name;
                        return this.getHomeConfigId(hcs);
                      });

                    Promise.all(masterPromises)
                      .then((results) => {
                        results.forEach((homeConfigId) => {
                          if (homeConfigId) {
                            masterHomeConfigIds.push(homeConfigId);
                          }
                        });
                        this.copyToStyleTemplate(masterHomeConfigIds);
                      })
                      .catch((err) => {
                        this.showMessage("Failed to get home configs.");
                      });
                  } else {
                    this.showMessage("Failed to load ifc files.");
                  }
                })
                .catch((err: any) => {
                  this.showMessage("Failed to load ifc files.");
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          });
        break;
      case "Options":
        let optionsHomeConfigIds: string[] = [];
        this.getHomeConfig(this.selectedHomeConfigId)
          .then((getHomeConfigResponse: GetHomeConfigResponse | void) => {
            if (getHomeConfigResponse?.success && getHomeConfigResponse.homeConfig) {
              let hcs = new HomeConfigSlim();
              hcs.home = getHomeConfigResponse.homeConfig!.home;
              hcs.masterFile = getHomeConfigResponse.homeConfig!.masterFile;
              hcs.companyId = this.selectedCompany?.id;

              if (!getHomeConfigResponse.homeConfig?.options || getHomeConfigResponse.homeConfig.options.length < 1) {
                return;
              }

              const optionsPromises: Promise<string | undefined>[] = getHomeConfigResponse.homeConfig.options
                .map((option: string) => {
                  hcs.options = [option];
                  return this.getHomeConfigId(hcs);
                });

              Promise.all(optionsPromises)
                .then((results) => {
                  results.forEach((homeConfigId) => {
                    if (homeConfigId) {
                      optionsHomeConfigIds.push(homeConfigId);
                    }
                  });
                  this.copyToStyleTemplate(optionsHomeConfigIds);
                })
                .catch((err) => {
                  this.showMessage("Failed to get home configs.");
                });
            }
          });
        break;
    }
  }

  private loadIfcFiles(homeId: string) {
    if (!this.selectedCompany?.code) {
      return Promise.resolve();
    }
    this.loading = true;

    var request = new ListIfcFilesByHomeIdRequest();
    request.companyId = this.selectedCompany.id;
    request.homeId = homeId;

    return this.homeService.ListIfcFilesByHomeId(request);
  }  
  
  private getHomeConfig(homeConfigId: string) {
    if (!this.selectedCompany?.code) {
      return Promise.resolve();
    }
    this.loading = true;

    let request = new GetHomeConfigRequest();
    request.homeConfigId = homeConfigId;

    return this.situViewClient.getHomeConfig(request);
  }

  private getHomeConfigId(homeConfig: HomeConfigSlim) {
    let request = new GetHomeConfigSlimIdRequest();
    request.companyId = this.selectedCompany?.id;
    request.homeConfig = homeConfig;

    return this.homeService.GetHomeConfigId(request)
      .then((response: GetHomeConfigSlimIdResponse) => {
        if (!response?.success) {
          this.showMessage("Home Config is invalid.");
        } else {
          return response.homeConfigId;
        }
      });
  }

  hasReleaseItems: boolean = false;
  releaseItems: string[] | undefined;
  private getReleaseItems() {
    if (!this.selectedCompany?.id || !this.renderedOutput?.id || !this.isReleaseUser) {
      return;
    }

    let request = new ListReleaseItemsRequest();
    request.companyId = this.selectedCompany.id;
    request.renderedOutputId = this.renderedOutput.id;

    this.situViewClient.listReleaseItems(request)
      .then((response: ListReleaseItemsResponse) => {
        if (response?.success && response?.items && response?.items.length > 0) {
          this.hasReleaseItems = true;
          this.releaseItems = response.items.map(x => x.id).filter((id): id is string => id !== undefined);
        } else {
          this.hasReleaseItems = false;
          this.releaseItems = undefined;
        }
      })
  }
  /* releases */
}

export class GetSituViewResponseExtended extends GetSituViewResponse {
  shareUrl: string | undefined;
  situViewUrl: string | undefined;
  situPlanUrl: string | undefined;
  situRenderUrls: string[] | undefined;
  apiCode: string | undefined;
  prismApiCode: string | undefined;
  resStandardArtifactId: string | undefined;
  resRaytracedArtifactId: string | undefined;
  resRaytracedPlusArtifactId: string | undefined;
  resVrArtifactId: string | undefined;
  resPlanArtifactId: string | undefined;
  resInsightsArtifactId: string | undefined;
  resRenderArtifactId: string | undefined;
  resUnrealArtifactId: string | undefined;

  constructor(baseInstance: GetSituViewResponse) {
    super(baseInstance);
  }
}
